import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import UpdateDeliveryOffer from '../updateDeliveryOffer/UpdateDeliveryOffer';

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    marginTop: theme.spacing(3)
  },
  paper: {
    padding: theme.spacing(2),
    margin: 'auto',
    maxWidth: 500
  }
}));

/**
 * Affiche les informations de base sur la commande
 * ( dimension du colis, montant de l'assurance, coût de l'assurance... )
 */
const PackageInformations = ({ currentCommand }) => {
  const {
    type: { height, length, weight, width },
    pickupPoint,
    insuranceAmount,
    insuranceCost
  } = currentCommand;
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <Paper className={classes.paper}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm container>
            <Grid item xs container direction="column" spacing={2}>
              <Grid item xs>
                <Typography gutterBottom variant="body2">
                  Dimension : {length} cm x {width} cm x {height} cm
                </Typography>
                <Typography variant="body2" gutterBottom>
                  Poids : {weight} kg
                </Typography>
                <UpdateDeliveryOffer command={currentCommand} />
                {pickupPoint && (
                  <>
                    <Typography variant="body2" gutterBottom>
                      {`Id du point relais : ${pickupPoint.id}`}
                    </Typography>
                    <Typography variant="body2" gutterBottom>
                      {`Nom du point relais : ${pickupPoint.name}`}
                    </Typography>
                    <Typography variant="body2" gutterBottom>
                      {`Adresse du point relais : ${
                        pickupPoint.address.street
                      }, ${pickupPoint.address.postalCode}, ${
                        pickupPoint.address.city
                      }, ${pickupPoint.address.country}`}
                    </Typography>
                  </>
                )}
                <Typography variant="body2" gutterBottom>
                  Assurance : {insuranceAmount} €
                </Typography>
                <Typography variant="body2" gutterBottom>
                  {"Prix de l'assurance :"} {insuranceCost} €
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Paper>
    </div>
  );
};

const mapStateToProps = state => ({
  currentCommand: state.commands.currentCommand
});

PackageInformations.propTypes = {
  currentCommand: PropTypes.object.isRequired
};

export default connect(mapStateToProps)(PackageInformations);
